import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

/**
 * Legacy WordPress FAQ category archives (/faq-type/post-op-hair-transplant/ etc.)
 * now live as sections on the single FAQ page.
 */
export const Route = createFileRoute("/faq-type/$slug")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/hair-transplant-faqs/", location.searchStr), statusCode: 301 });
  },
});
